module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_1.6e826d78.png";